export default "__VITE_ASSET__DGqO4d7L__"